export const ENABLED = true;

export const FONT_FAMILY = 'default';
export const FONT_SIZE = -1;
export const LETTER_SPACING = 0;
export const LINE_HEIGHT = 1.2;
export const PAGE_MARGIN = 1;
export const THEME = 0;
